import { render, staticRenderFns } from "./order_info.vue?vue&type=template&id=e43b60f6&scoped=true"
import script from "./order_info.vue?vue&type=script&lang=js"
export * from "./order_info.vue?vue&type=script&lang=js"
import style0 from "./order_info.vue?vue&type=style&index=0&id=e43b60f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43b60f6",
  null
  
)

export default component.exports